const name = (data, row) => {

    let img = ''
    if (!!row.thumbnail) {
        const host = process.env.NODE_ENV === "development" ? "http://localhost:8000" : ""
        const src = host + row.thumbnail
        img = `<img src="${src}" width="42px" height="42px" class="mr-1"/>`;
    }
      return `
    <div class="d-flex flex-direction-row align-items-center">
        ${img}
        <div>${row.name}</div>
    </div>

    `;
};

export default {
  name
};
